/**
 * @ngdoc type
 * @name UserProfile
 * @module mx.app
 *
 * @description
 * An user profile implementation
 *
 * @property {object} id - Gets or sets user identifier.
 * @property {string} firstName - Gets or sets user first name.
 * @property {string} lastName - Gets or sets user last name.
 * @property {string} accountName - Gets or sets user account name.
 * @property {string} avatar - Gets or sets user avatar.
 * @property {string} email - Gets or sets user email.
 * @property {string} phone - Gets or sets user phone.
 * @property {object} languageId - Gets or sets user language identity.
 * @property {boolean} isDevMode - Gets or sets whether the user has Development Mode rights.
 * @property {boolean} isCustomMode - Gets or sets whether the user has Customization Mode rights.
 * @property {boolean} isAdmin - Gets or sets whether the user has Admin Mode rights.
 * @property {guid} objectId - Gets or sets user object id;
 * @property {enum} status - Gets or sets user status
 * @property {guid} profileDialogId - Gets or sets user profile dialog id
 * @property {string[]} invariantRoleNames - Gets user roles
 * @property {string} [userType] - Gets user type
 * @property {string} [createdDate] - Gets user created date
 * @property {string} [lastActivityDate] - Gets user last activity date
 */
export class UserProfile {
	constructor(
		public id: string,
		public firstName: string,
		public lastName: string,
		public accountName: string,
		public avatar: string,
		public email: string,
		public phone: string,
		public languageId: string,
		public isDevMode = false,
		public isCustomizationMode = false,
		public isAdmin = false,
		public objectId: string,
		public status: number,
		public profileDialogId: string,
		public readonly invariantRoleNames: string[],
		public readonly userType?: string,
		public readonly createdDate?: string,
		public readonly lastActivityDate?: string
	) {}
}
